class RouteActions {
    private $state: any;

    public setup($state: any) {
        this.$state = $state;
    }

    public goToRoute(route: string, params?: any) {
        this.$state.go(route, params);
    }
}
const instance = new RouteActions();
export default instance as RouteActions;